export default __webpack_public_path__ + "static/media/logo.811ce066.png";